import { render } from "./InvoiceListTable.vue?vue&type=template&id=7bb4b0a8"
import script from "./InvoiceListTable.vue?vue&type=script&lang=js"
export * from "./InvoiceListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__